import React from "react";
import Navbar from '../accueil/navbar/Navbar';
import Footer from '../accueil/footer/Footer';
import Bureau from "./apropos/Apropos";
import './apropos/Apropos.css';

const SERVER_ADDRESS = process.env.REACT_APP_SERVER_ADDRESS;

class DisplayApropos extends React.Component {
    constructor() {
        super();
        this.state = {
            apropo: []
        }
    }

    componentDidMount = () => {
        fetch(SERVER_ADDRESS + '/apropos')
            .then(res => res.json())
            .then(res => this.setState({ apropo: res }))
    }

    render() {
        return (
            <div className="sticky-wrap">
                <Navbar />
                <div className="block-titre-apropos">

                    <strong className="title_glob">A propos</strong>

                </div>

                <div className="column align-items-center">
                    <div className="all_apropos_page row">

                        {this.state.apropo.map((apropos) => (
                            <Bureau
                                lieux={apropos.lieux}
                                nom={apropos.nom}
                                fonction={apropos.fonction}
                            />
                        ))}
                    </div>

                    <div className="wi-12 block-titre-apropos">

                        <strong className="title_glob">Crédit</strong>

                    </div>

                    <div className="credit row">

                        <div className="credit-user">
                            <p>Fabien Fiette</p>
                            <p>fabienfiette@hotmail.fr</p>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/fabien-fiette/">Likedin</a>
                        </div>

                        <div className="credit-user">
                            <p>Patrice Leroux</p>
                            <p>lerouxp541@gmail.com</p>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/patrice-leroux/">Likedin</a>
                        </div>

                        <div className="credit-user">
                            <p>Nicolas Lambinet</p>
                            <p>lambinet.nicolas@gmail.com</p>
                            <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/lambinet-nicolas/">Likedin</a>
                        </div>

                    </div>

                </div>

                <div className="sticky-footer">
                    <Footer />
                </div>
            </div >
        )
    }
}

export default DisplayApropos;
